import { ChangeEvent, FC } from 'react';
import InputMask from 'react-input-mask';
import classNames from 'classnames';
import { IBaseField } from '.';
import { FieldControl } from 'src/UI';
import st from './Control.module.scss';

interface IMaskInputProps extends IBaseField {
	/** Маска ввода */
	mask?: string;
	/** Символ-заполнитель для не введенных позиций */
	maskChar?: string | null;
	/** Пользовательские символы маски, например { S: [А-Яа-яЁё] } */
	formatChars?: Record<string, string>;
	/** Автоматически приводить вводимые символы к верхнему регистру */
	autoUpperCase?: boolean;
	/** Флаг фокуса */
	autoFocus?: boolean;
	/** Идентификатор поля */
	id?: string;
}

/**
 * Текстовое поле с маской
 */
const MaskInput: FC<IMaskInputProps> = (props) => {
	const {
		name,
		title,
		isRequired = false,
		disabled = false,
		mask = '',
		placeholder,
		value,
		touched = false,
		error,
		onChange,
		onBlur,
		size = 'std',
		autoFocus = false,
		id,
		maskChar = null,
		formatChars,
		autoUpperCase = false,
	} = props;

	const inputClasses = classNames(st.input, st[size], {
		[st.inValidate]: touched && error,
	});

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (autoUpperCase) {
			e.target.value = e.target.value.toUpperCase();
		}
		onChange?.(e);
	};

	return (
		<FieldControl
			name={name}
			title={title}
			isRequired={isRequired}
			isInvalid={!!touched && !!error}
			isTouched={touched}
			errorMsg={error}
		>
			<InputMask
				id={id}
				name={name}
				value={value ?? ''}
				onChange={handleChange}
				onBlur={onBlur}
				mask={mask}
				{...(formatChars
					? ({ formatChars } as Record<string, unknown>)
					: {})}
				alwaysShowMask={!placeholder}
				placeholder={placeholder}
				className={inputClasses}
				type="text"
				disabled={disabled}
				maskChar={maskChar}
				autoFocus={autoFocus}
			/>
		</FieldControl>
	);
};

export default MaskInput;
